module.exports = __webpack_public_path__ + "assets/img/thumb-Earlytrade-Social-Static-Ad.2ab22a60.jpg";